import NextImage, { ImageLoaderProps } from 'next/image';

import {
  ContentfulResizeTypes,
  getContentfulLoader,
} from '../../../helpers/imageLoaders/contentful';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../Heading/Heading';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import speciesPlaceholderImg from '../assets/speciesPlaceholderImg.png';

interface IProps {
  linkPath: string;
  cardTitle: string;
  descriptiveText: string;
  imageAlt: string;
  imageUrl?: string | undefined;
}

export const BlogPostCategoryCard = ({
  linkPath,
  cardTitle,
  descriptiveText,
  imageAlt,
  imageUrl,
}: IProps) => {
  const ASPECTWIDTH = 200;
  const ASPECTHEIGTH = 200; // aspect ratio = 67%
  const contentfulLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getContentfulLoader(src, width, ASPECTWIDTH, ASPECTHEIGTH, {
      quality,
      resize: ContentfulResizeTypes.FILL,
    });

  return (
    <InternalLink
      to={linkPath}
      className="flex w-full justify-between rounded-lg bg-sea-foam drop-shadow-phoneMobile sm:drop-shadow-phoneDesktop"
    >
      <div className="relative flex aspect-square w-2/6 rounded-l-lg p-4 md:w-4/12">
        {imageUrl ? (
          <NextImage
            alt={imageAlt}
            src={imageUrl}
            loader={contentfulLoader}
            height={200}
            width={200}
            unoptimized
            className="size-full max-h-[200px] max-w-[200px] object-contain"
          />
        ) : (
          <NextImage
            alt="Species placeholder"
            src={speciesPlaceholderImg}
            unoptimized
            className="size-full max-h-[200px] max-w-[200px] object-contain"
          />
        )}
      </div>

      <div className="flex w-3/6 flex-col justify-center p-2 sm:p-3 md:w-6/12">
        <Heading as="h3" variant="xs" className="mb-1">
          {cardTitle}
        </Heading>
        <span className="mb-0 block !text-xs">{descriptiveText}</span>
      </div>
      <div className="mx-auto flex w-1/6 items-center md:w-2/12">
        <ArrowRightIcon className="mx-auto" />
      </div>
    </InternalLink>
  );
};
